// Maximum lengths for text input fields
export const MAX_DEFAULT = 250;
export const MAX_SMALL = 100;
export const MAX_DEFAULT_ERROR = `Maximum length is ${MAX_DEFAULT} characters`;
export const MAX_SMALL_ERROR = `Maximum length is ${MAX_SMALL} characters`;
